import React from "react";
import TableHeader from "@components/TableHeader";
import Printfiled from "./Printfiled";
import ReusableTable from "@components/ReusableTable";
import { useTranslation } from "react-i18next";
import { getCharge, getEarn, getTravelerPrice } from "../../Actions";

const Car = (props) => {
  const { t } = useTranslation();
  const header = [
    {
      title: "tarif_date",
      width: 7,
      align: "left",
      filed: "date",
    },
    {
      title: "availability",
      width: 8,
      align: "center",
      filed: "car_available",
    },

    {
      title: "base_amount",
      width: 18,
      align: "center",
      filed: "base_amount",
      filedList: ["price"],
    },
    {
      title: "charge",
      width: 18,
      align: "center",
      filed: "charge",
      filedList: ["price"],
    },
    {
      title: "amount_traveler",
      width: 18,
      align: "center",
      filed: "amount_traveler",
      filedList: ["price"],
    },
    {
      title: "you_earn",
      width: 18,
      align: "center",
      filed: "you_earn",
      filedList: ["price"],
    },
    { title: "", width: 5, align: "center", filed: "is_stop_sales" },
    { title: "", width: 5, align: "center", filed: "button" },
  ];
  const bookingColumns = [

    { key: 'date', label: t('tarif_date'), width: '120px' },
    { key: 'car_available', label: t('availability'), width: '120px' },
    { key: 'price', label: t('base_amount'), width: '150px' },
    { key: 'price', label: t('charge'), width: '150px' ,  
      render: (value,row) => (
        <div className="">
         {getCharge(
                           value,
                           row.charge_service,
                           row.charge_service_type
                         )}
        </div>
      )
    },
    { key: 'price', label: t('amount_traveler'), width: '150px',  
      render: (value,row) => (
        <div className="">
         {getTravelerPrice(
                  value,
                  row.charge_service,
                  row.charge_service_type
                )}
        </div>
      )},
    { key: 'price', label: t('you_earn'), width: '150px' ,  
      render: (value,row) => (
        <div className="">
         {getEarn(
                     value,
                  row.charge_service,
                  row.charge_service_type
                    )}

        </div>
      )}, 
  
  ];
  console.log("prices",props.prices)
  return (
    <>
      <p className="mt-1 fw-normal">{props.t("ho_act_Opt_TarifTxt1")}</p>

      <div class="tableFixHead">
        <TableHeader header={header} />
        <table>
          <tbody>
            {props.prices.map((item, index) => (
              <tr>
                {header.map((head) => (
                  <td
                    className="cell100"
                    style={{ width: head.width + "%", textAlign: head.align }}
                  >
                    <Printfiled
                      tarif={item}
                      filed={head.filed}
                      filedList={head?.filedList}
                      onStopSales={props.onStopSales}
                      priceForm={props.priceForm}
                      config={props.config}
                      dataIndex={{
                        item: item,
                        index: item,
                      }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ReusableTable
        data={props.prices}
        columns={bookingColumns}
        // onDetails={handleDetails}
        // onRowClick={handleDetails}

        colors={{
          headerBg: '#7c3aed',
          buttonDetails: '#10b981',
          rowHover: '#f0f3ff',
          border: '#e5e7eb'
        }}
      />
    </>
  );
};
export default Car;
